<template>
  <div>
	<audio controls style="width: 250px; height: 34px; vertical-align: bottom;">
		<source :src="record.url" />
	</audio>	
    <!--audio controls="controls" :src="record.url" style="width: 250px; height: 34px; vertical-align: bottom;"></audio-->
	<span style="padding-left: 50px;height: 34px;">{{record.name}}</span>
	<span style="padding-left: 50px;height: 34px;">{{record.created_at}}</span>
	<span style="padding-left: 50px;height: 34px;">{{record.url}}</span>
  </div>
</template>

<script>
export default {
 props: ['record'],
  methods: {
    play() {
      this.$refs.audio.play();
    },
    pause() {
      this.$refs.audio.pause();
    }
  }
};
</script>
